import * as React from "react";

export function Tabs({ value, onValueChange, children, className, defaultValue }: any) {
  const [current, setCurrent] = React.useState(defaultValue ?? value);

  const change = (v: string) => {
    setCurrent(v);
    onValueChange?.(v);
  };

  return <div className={className}>{React.Children.map(children, (child: any) =>
    React.cloneElement(child, { current, change })
  )}</div>;
}

export function TabsList({ children, className, current, change }: any) {
  return <div className={className}>{React.Children.map(children, (child: any) =>
    React.cloneElement(child, { current, change })
  )}</div>;
}

export function TabsTrigger({ value, children, className, current, change }: any) {
  return (
    <button
      onClick={() => change(value)}
      className={`${className} ${current === value ? "font-bold border-b-2" : ""}`}
    >
      {children}
    </button>
  );
}

export function TabsContent({ value, children, current, className }: any) {
  if (current !== value) return null;
  return <div className={className}>{children}</div>;
}
